<div class="container h-100 w-100" *ngIf="!hideLoginUI">
  <div class="mx-auto d-flex justify-content-center align-items-center h-100">
    <div class="left-Side-cover w-50 h-100 d-none d-lg-block"></div>
    <div class="right-Side-cover w-50 h-100 d-none d-lg-block"></div>
    <div class="card mb-0 mx-auto w-75">
      <div class="row">
        <!-- Logo and card  loginbox mx-auto-->
        <div class="col-lg-6 col-sm-12">
          <div
            class="d-flex justify-content-center w-100"
            [ngClass]="showErrorDiv ? 'py-3' : 'py-2'"
          >
            <div
              *ngIf="showErrorDiv"
              class="bg-danger-subtle d-flex justify-content-between p-2 w-75"
            >
              <div>
                <span class="text-danger-emphasis">
                  <i [class]="icon"></i> {{ currentMessage }}
                </span>
              </div>
              <div>
                <button
                  type="button"
                  class="btn-close me-2 m-auto"
                  data-bs-dismiss="toast"
                  aria-label="Close"
                  (click)="close()"
                ></button>
              </div>
            </div>
          </div>
          <div
            class="d-flex flex-column my-1"
            [ngClass]="showErrorDiv ? 'py-3' : 'py-5'"
          >
            <!-- Logo Div -->
            <div class="text-center">
              <img
                src="assets/caregenix/images/logo/svg-carevance-hori-logo.svg"
                alt="logo"
                class="logo-dark"
              />
            </div>
            <!-- Cards Container -->
            <div class="text-center py-3">
              <h2 class="text-Login">{{ translate("LOGIN") }}</h2>
            </div>
            <div class="px-3">
              <app-input-static-fields
                code="ti ti-at"
                label="{{ translate('USERNAME') }}"
                [formGroup]="loginForm"
                type="text"
                formControlValue="username"
                [name]="'username'"
              />
              <app-input-static-fields
                code="ti ti-lock"
                label="{{ translate('PASSWORD') }}"
                [formGroup]="loginForm"
                formControlValue="password"
                type="password"
                [name]="'password'"
                (keydown.enter)="submitForm($event)"
              />
            </div>

            <div class="d-flex justify-content-between px-3">
              <app-checkbox
                title="Remember me?"
                [formGroup]="loginForm"
                formControlValue="rememberMe"  [checked]="loginForm.get('rememberMe')?.value"
              />
              <a
                href="#"
                (click)="openModal($event, centermodal, { centered: true })"
                data-bs-target="#centermodal"
              >
                <u class="forgetPassword"
                  ><span class="forgetPassword">{{
                    translate("FORGETPASSWORD")
                  }}</span></u
                >
              </a>
            </div>

            <div class="px-3 py-2" [hidden]="isLocalhost">
              <div #turnstileContainer class="w-100"></div>
            </div>

            <div class="px-3 py-3">
              <button
                class="btn btn-lg w-100 btnLogin"
                [disabled]="!isLocalhost && !turnstileToken"
                (click)="submitForm($event)"
              >
                {{ translate("LOGIN") }}
              </button>
            </div>

            <!-- <select class="form-select languagedropdown" (change)="switchLanguage($event)">
                        <option value="en">English</option>
                        <option value="fr">French</option>
                      </select>   -->
          </div>
        </div>
        <div class="col-lg-6 bg-cover d-none d-lg-block p-0">
          <app-image-side customClass="" />
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template
  #centermodal
  let-modal
  class="modal fade"
  id="centermodal"
  tabindex="-1"
  role="dialog"
  aria-hidden="true"
>
  <app-forget-password (modalDismiss)="handleModalDismiss()" />
</ng-template>
<ng-template
  #passwordModal
  let-modal
  class="modal fade"
  id="passwordModal"
  tabindex="-1"
  role="dialog"
  aria-hidden="true"
>
  <app-set-new-password
    (modalDismiss)="handleModalDismiss()"
    [username]="loginForm.value.username"
    (isPasswordChanged)="passwordChanged($event)"
    [previousPassword]="this.loginForm.value.password"
  />
</ng-template>
